module.exports = __webpack_public_path__ + "img/23-MUTAMX.aede8045.jpg";